import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const DeviceCategoriesFilter = ({
    deviceCategories,
    loading,
    filters,
    restoreFilterValues,
}) => (
    <Field
        className='--customWidth --deviceCategories'
        component={Form.ReduxSelect}
        name='deviceCategories'
        placeholder='Device category'
        options={deviceCategories}
        search
        loading={loading}
        multiple
        disabled={loading}
        setValue={restoreFilterValues(filters, 'deviceCategories')}
    />
);

DeviceCategoriesFilter.propTypes = {
    deviceCategories: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};
